var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C5F66",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.969 4.673a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0M8.785 7.669v3.605a.91.91 0 1 1-1.82 0V7.67a.91.91 0 0 1 1.82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm4.579 12.454a6.478 6.478 0 0 1-9.196.038 6.474 6.474 0 0 1 .038-9.196 6.478 6.478 0 0 1 9.196-.038 6.474 6.474 0 0 1-.038 9.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm4.579 12.454a6.478 6.478 0 0 1-9.196.038 6.474 6.474 0 0 1 .038-9.196 6.478 6.478 0 0 1 9.196-.038 6.474 6.474 0 0 1-.038 9.196z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.30a7af0b.svg";
export { ForwardRef as ReactComponent };